import React, {useMemo} from 'react';

import {Application} from 'components/JobBoardDetails'
import ApplicationsListItem from "./ApplicationsListItem";

import {ApplicationListItemContainer} from './ApplicationsList.styles'

interface ApplicationsListProps {
    onApplicationClick: (application: Application) => void
    applicationType: string
    sortedApplications: {
        newCandidates: Application[],
        shortlistedCandidates: Application[],
        declinedCandidates: Application[],
        viewedCandidates: Application[]
    }
}

const ApplicationsList = ({onApplicationClick, applicationType, sortedApplications}: ApplicationsListProps) => {
    const {newCandidates, shortlistedCandidates, declinedCandidates, viewedCandidates} = sortedApplications;
    
    return (
        <>
        { applicationType==="newOrViewed" && (
            <>
                {newCandidates.length > 0 ? (
                        newCandidates.map((application) => (
                            <ApplicationListItemContainer $isNew={true}>
                                <ApplicationsListItem
                                    key={application.applicationId}
                                    isNew={true}
                                    application={application}
                                    onApplicationClick={onApplicationClick}
                                />
                            </ApplicationListItemContainer>
                        ))
                    ) : ""}
                {viewedCandidates.length > 0 ? (
                    viewedCandidates.map((application) => (
                        <ApplicationListItemContainer $isNew={false}>
                            <ApplicationsListItem
                                key={application.applicationId}
                                application={application}
                                onApplicationClick={onApplicationClick}
                            />
                        </ApplicationListItemContainer>

                    ))
                ) : ""}
                {!newCandidates.length && !viewedCandidates.length ? "There are no new or viewed candidates currently" : ""}
            </>
            )
        }
        { applicationType === "shortlisted" && (
            shortlistedCandidates.length > 0 ? (
                shortlistedCandidates.map((application) => (
                    <ApplicationListItemContainer $isNew={false}>
                    <ApplicationsListItem
                        key={application.applicationId}
                        isShortlisted={true}
                        application={application}
                        onApplicationClick={onApplicationClick}
                    />
                    </ApplicationListItemContainer>
                ))
            ) : "There are no shortlisted candidates currently"
        )}
        { applicationType === "hideCandidates" && (
            declinedCandidates.length > 0 ? (
                declinedCandidates.map((application) => (
                    <ApplicationListItemContainer $isNew={false}>
                        <ApplicationsListItem
                            key={application.applicationId}
                            application={application}
                            onApplicationClick={onApplicationClick}
                            isHidden={true}
                        />
                    </ApplicationListItemContainer>
                ))
            ) : "There are no hidden candidates currently"
        )}
        </>
    )
}

export default ApplicationsList;
